import React, { useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, Card, CircularProgress } from '@material-ui/core';
import useYext from '../hooks/useYext';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
  },
  card: {
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    overflow: 'hidden',
  },
  emptyState: {
    padding: theme.spacing(6),
    textAlign: 'center',
    color: '#666',
  },
  loadingState: {
    padding: theme.spacing(6),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  iframeContainer: {
    width: '100%',
    minHeight: '800px',
    height: 'auto',
    position: 'relative',
    margin: 0,
    marginTop: '-60px',
    padding: 0,
    zIndex: 0,
  },
  iframe: {
    width: '100%',
    minHeight: '800px',
    border: 'none',
    display: 'block',
    margin: 0,
    padding: 0,
  },
}));

const ScanResults = () => {
  const classes = useStyles();
  const { scanResults, currentLocation, isScanning } = useYext();
  const iframeRef = useRef(null);

  if (isScanning) {
    return (
      <Box className={classes.container}>
        <Card className={classes.card}>
          <Box className={classes.loadingState}>
            <CircularProgress size={48} />
            <Typography variant="h6" color="textSecondary">
              Scanning {currentLocation?.name || 'location'}...
            </Typography>
            <Typography variant="body2" color="textSecondary">
              This may take a few moments
            </Typography>
          </Box>
        </Card>
      </Box>
    );
  }

  // Show empty state when no scan results
  if (!scanResults) {
    return (
      <Box className={classes.container}>
        <Card className={classes.card}>
          <Box className={classes.emptyState}>
            <Typography variant="h6" gutterBottom>
              PowerListings Scan Results
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Select a location and click &quot;Scan Location&quot; to view listing reports
            </Typography>
          </Box>
        </Card>
      </Box>
    );
  }

  // Display the HTML scan results in an iframe using srcDoc
  return (
      <div className={classes.iframeContainer} id="powerlistings-scan-results">
        <iframe
          ref={iframeRef}
          srcDoc={scanResults}
          className={classes.iframe}
          title="PowerListings Scan Results"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-popups-to-escape-sandbox"
          loading="lazy"
        />
      </div>
  );
};

export default ScanResults;
